<script setup>
import { usePage } from '@inertiajs/vue3'
import { computed } from 'vue'

const page = usePage()
const versions = computed(() => page.props.versions ?? {})

const segments = computed(() => {
  const parts = []

  if (versions.value.app) {
    parts.push(`Hindamine ${versions.value.app}`)
  }

  if (versions.value.ml_api) {
    parts.push(`ML-api ${versions.value.ml_api}`)
  }

  if (versions.value.pipeline) {
    parts.push(`Pipeline ${versions.value.pipeline}`)
  }

  return parts
})
</script>

<template>
  <footer v-if="segments.length" class="mt-auto py-2 text-center text-xs text-gray-400 select-all">
    {{ segments.join('  ·  ') }}
  </footer>
</template>
